import { TOGGLE_HEADER_PIN, SET_HEADER_PIN_STATE } from "./types";

export const toggleHeaderPin = (pathname) => ({
  type: TOGGLE_HEADER_PIN,
  payload: { pathname },
});

export const setHeaderPinState = (pathname, isPinned) => ({
  type: SET_HEADER_PIN_STATE,
  payload: { pathname, isPinned },
});
